<template>
  <el-dialog
    class="audio-player"
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="dialogVisible"
  >
    <div class="audio-box">
      <div class="player-box">
        <audio
          :src="audioList[playingIndex].url"
          width="100%"
          controls
          autoplay
          muted
          webkit-playsinline="true"
          playsinline="true"
          controlsList="nodownload"
        ></audio>
      </div>
      <div class="list-box">
        <div
          v-for="(item, index) in audioList"
          :key="item.key"
          class="audio-item"
          :class="playingIndex == index ? 'audio-item-active' : ''"
          @click="changePlayingAudio(index)"
        >
          <div class="audio-cover">
            <el-image class="cover-image" :src="item.cover" fit="cover"></el-image>
          </div>
          <div class="audio-title">{{ item.title }}</div>
        </div>
      </div>
      <div class="close-btn" @click="closeHandle">
        <span class="el-icon-circle-close"></span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/*
视频集播放器
*/
export default {
  name: "audioPlayer",
  props: {
    dialogTitle: {
      type: String,
      default: "播放音频"
    },
    visible: {
      type: Boolean,
      default: false
    },
    audioList: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  data() {
    return {
      dialogVisible: false,
      playingIndex: 0,
    }
  },
  methods: {
    changePlayingAudio(index) {
      this.playingIndex = index
    },
    closeHandle() {
      this.$emit('dialogClose')
    },
  }
}
</script>

<style lang="scss" scoped>
.audio-player{
  text-indent: 0;

  .audio-box{

    .player-box{
      width: 100%;
      height: 422px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .list-box{
      padding: 24px 15px;
      overflow: hidden;
      // overflow-x: scroll;
      white-space: nowrap;

      .audio-item{
        width: 120px;
        display: inline-block;
        margin-right: 10px;

        .audio-cover{
          width: 120px;
          height: 150px;
          display: flex;
          align-items: center;

          .cover-image{
            width: 120px;
            height: 120px;
          }
        }

        .audio-title{
          width: 120px;
          padding: 10px;
          font-size: 16px;
          line-height: 24px;
          color: #fff;
          opacity: 0.65;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .audio-item-active{
        width: 150px;
        
        .audio-cover{
          width: 150px;
          height: 150px;
          border: 5px solid #0FC29A;
          box-sizing: border-box;

          .cover-image{
            width: 140px;
            height: 140px;
          }
        }
        
        .audio-title{
          width: 150px;
        }
      }
    }
    
    .close-btn{
      font-size: 40px;
      color: #e3e3e3;
      position: absolute;
      bottom: -90px;
      left: 50%;
      margin-left: -23px;
      cursor: pointer;
    }
  }
}
/deep/.el-dialog{
  width: 750px;
  background: rgba(0, 0, 0, 0.65);

  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
}
</style>